export default function({ route, redirect, params }) {
  // 末尾に「/」がなく、urlパラメータが存在しない場合、
  // 末尾に「/」を付与して、301リダイレクトする
  if (route.path.slice(-1) !== '/') {
    let query = ''
    if (Object.keys(route.query).length >= 1) {
      const URLSearchParams = require('url').URLSearchParams
      const params = new URLSearchParams(route.query)
      query += '?' + params.toString()
    }
    const hash = route.hash ? route.hash : ''
    const encodePath = encodeURI(route.path)
    redirect(301, encodePath + '/' + query + hash)
  }

  if (route.path === '/s/' && route.query.q) {
    // スラッシュのエンコード対応（%2F⇒%25252F）
    const keyword = encodeURIComponent(route.query.q).replace(/%2F/g, '%25252F')
    redirect(301, '/s/q-' + keyword + '/')
  }
  // tagの指定無くまとめページアクセス時はまとめ一覧ページへリダイレクト
  if (route.path === '/sm/' && Object.keys(params).length < 1) {
    redirect(301, '/summary/')
  }
  // stationページのdefaultエリアを指定
  if (route.path === '/station/' && Object.keys(params).length < 1) {
    redirect(301, { name: 'station-all', params: { pathMatch: 'ar-関東' } })
  }

  switch (route.path) {
    case '/help/':
      redirect(301, process.env.HELP_PAGE)
      break
    case '/contact/':
      redirect(301, process.env.CONTACT_PAGE)
      break
    case '/request/':
      redirect(301, process.env.REQUEST_PAGE)
      break
    case '/gp/company/':
      redirect(301, process.env.COMPANY_PAGE)
      break
  }
}
